import script from "./CTaxCalculatorIndividual.vue?vue&type=script&setup=true&lang=js"
export * from "./CTaxCalculatorIndividual.vue?vue&type=script&setup=true&lang=js"

import "./CTaxCalculatorIndividual.vue?vue&type=style&index=0&id=58d8a662&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d8a662"]])

export default __exports__